export const message = {
    steward: {
        // 管家消息相关
        title: '标题：',
        send: '发送：',
        sendTime: '发送时间：',
        sendContent: '发送内容：',
        byDepartment: '按部门',
        byProject: '按项目',
        byRole: '按角色',
        recalled: '已撤回',
        selectDepartment: '选择部门',
        selectProject: '选择项目',
        selectRole: '选择角色',
        content: '内容',
        sendMessage: '发送消息',
        recall: '撤回',
        deleteWarning: '确认要删除吗',
        notification: '通知',
        pleaseInput: '请输入',
        pleaseSelect: '请选择',
        selectedCount: '选中{count}人',
        selecteHint: '请选择发送对象',
    },
    stewardMessage: '管家消息',
    stewardCenter: '管家中心',
    markAll: '全部标记为已读',
};
